import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SectionHead from "./ui/SectionHead";
import { ArrowUpRight } from "./ui/Icons";

import img1 from "../image/img6.jpg";
import img2 from "../image/SMART-AGRO-CMR-1-800x400.jpg";
import img3 from "../image/tomato-greenhouse-farming.jpg";

/* One photograph per beat, each showing the moment the step describes. */
const STEPS = [
  {
    key: "one",
    img: img1,
    alt: "A grower bending over a potato bed to photograph the foliage close up",
  },
  {
    key: "two",
    img: img2,
    alt: "A grower reading crop information from a tablet inside a greenhouse",
  },
  {
    key: "three",
    img: img3,
    alt: "A farmer harvesting healthy tomatoes into crates",
  },
];

/**
 * A three-beat sequence. Each step owns one photograph — previously the same
 * three images were shown twice on this section (a 2×2 collage and a numbered
 * list beside it), which read as filler.
 */
export default function SmarterSteps() {
  const { t } = useTranslation();

  return (
    <section className="section bg-agri-card">
      <div className="container-x">
        <SectionHead
          kicker={t("design.smarter.badge")}
          title={t("design.smarter.title")}
        >
          {t("design.smarter.desc")}
        </SectionHead>

        <ol className="grid grid-cols-1 gap-x-8 gap-y-12 sm:grid-cols-3 sm:gap-x-6 lg:gap-x-10">
          {STEPS.map((s, i) => (
            <li key={s.key} className="group">
              {/* Staggered top offsets give the row a hand-set baseline
                  instead of three identical boxes locked to a grid line */}
              <div className={i === 1 ? "sm:pt-10" : i === 2 ? "sm:pt-20" : ""}>
                <div className="overflow-hidden bg-agri-paperDeep">
                  <img
                    src={s.img}
                    alt={s.alt}
                    loading="lazy"
                    className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                  />
                </div>

                <div className="mt-6 flex items-baseline gap-4 border-t border-agri-rule pt-5">
                  <span className="figure text-[1.75rem] leading-none text-agri-clay">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h3 className="font-display text-[1.25rem] font-semibold leading-snug tracking-[-0.018em] text-agri-ink">
                      {t(`design.smarter.steps.${s.key}.title`)}
                    </h3>
                    <p className="mt-2 text-[0.9375rem] leading-[1.7] text-agri-ink80">
                      {t(`design.smarter.steps.${s.key}.desc`)}
                    </p>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-16 flex justify-center sm:mt-20">
          <Link to="/test-ai" className="btn-primary">
            {t("design.heroCta")}
            <ArrowUpRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
